import { clsx, type ClassValue } from 'clsx';

/**
 * Utility for conditionally joining classNames together
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
